var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area"},[_c('h1',[_vm._v("Información laboral")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('label',[_vm._v("Nombre: ")]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.usuario.Nombre))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c93fcdc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tablero/Usuario/informacionLaboral.vue
// module id = null
// module chunks = 